import { Component, inject } from "@angular/core";
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";
import { ItemLinkableBase } from "@app/shared/linkable/item-linkable-base";
import { Observable } from "rxjs";
import { IHasGuid } from "@app/shared/interfaces/IHasGuid";
import { IncidentService } from "../services/incident.service";
import { TranslatePipe, injectTranslation, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/incident/i18n/scope";
import { LinkableComponent } from "@app/shared/linkable/linkable.component";

@Component({
    selector: "incident-linkable",
    templateUrl: "./incident-linkable.component.html",
    styleUrls: ["./incident-linkable.component.scss"],
    imports: [LinkableComponent, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class IncidentLinkableComponent extends ItemLinkableBase {
    private _incidentDS = inject(IncidentService);
    private _pages = inject(Pages);
    private _tabService = inject(TabService);
    private _translation = injectTranslation(scope);

    hasAccessToItem(guid: string): Observable<boolean> {
        return this._incidentDS.hasAccessToIncident(guid);
    }

    async openTab(item: IHasGuid, hasAccess: boolean) {
        if (hasAccess) {
            this._tabService.generateTab(
                this._pages.IncidentDetail,
                item.guid,
                `(I) ${item[this.displayValueProp]}`
            );
        } else {
            // t() needs the scope loaded first; before ready() it throws in development.
            await this._translation.ready();
            this._toastr.warning(
                this._translation.t("incidentLinkable.notEnoughRights")
            );
        }
    }
}
